export default __webpack_public_path__ + "static/media/icon_elbwalker.e65f6eb8.svg";